import {local} from '../services/local';

export const TUTORIAL_COMPLETED = 'TUTORIAL_COMPLETED';
export const OPTIMISTICALLY_MARK_TEST_AS_COMPLETE = 'OPTIMISTICALLY_MARK_TEST_AS_COMPLETE';

export function completeTutorial(data = {}) {
  return function(dispatch) {
    local.set('tutorialCompleted', true);
    dispatch(setTutorialCompleted(data));
  };
}

export function setTutorialCompleted() {
  return {
    type: TUTORIAL_COMPLETED
  };
}

export function markTestAsComplete(testId) {
  return {
    type: OPTIMISTICALLY_MARK_TEST_AS_COMPLETE,
    testId
  };
}
